// removed by extract-text-webpack-plugin
module.exports = {"resultContainer":"sj_sk","result":"sj_sl","logo":"sj_v","details":"sj_cs","title":"sj_n","secondaryDetails":"sj_mt","priceRange":"sj_cy","showAll":"sj_rl","link":"sj_cx"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventInfo/styles.module.css
// module id = 1105
// module chunks = 27